import { DispatchDetailsGlobalDAO } from './DispatchDetailsGlobalDAO';

export class DispatchDetailsDAO extends DispatchDetailsGlobalDAO {
  constructor() {
    super('ster_dispatch_details');
  }
}
